export class AddOrEditTicketTagInput {
    public ticketId: number;
    public tagIds: Array<number>;

    constructor() {
        this.ticketId = 0;
        this.tagIds = new Array<number>();
    }
}
